import React, { useEffect, useState } from 'react';
import useRouteStatus from '../../../hooks/useRouteStatus';

import { useDispatch, useSelector } from 'react-redux';
import { submitSoftApplication } from '../../../actions/applications';
import useSessionEntity from '../../../hooks/useSessionEntity';

import checkmark from '../../../images/green_checkmark.svg';
import Loading from '../../shared/Loading';
import ReturnToMerchant from '../../shared/ReturnToMerchant';

export default function Vip({ location }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const session = useSelector(state => state.sessions.get('session'));
  const application = useSessionEntity('application');
  const merchant = useSessionEntity('merchant');
  useRouteStatus(location);

  useEffect(() => {
    if (!application.submitted) {
      setLoading(true);
      dispatch(submitSoftApplication(application)).then(() => setLoading(false));
    }
  }, []);

  if (loading) return <Loading active={true} />

  return (
    <div id="content" className="has-text-centered">
      <div className="is-size-4 has-text-weight-semibold">
        <img
          alt="Green Checkmark"
          src={checkmark}
        />
        <p>{session.hasCustomFlag('netx') ? 'Thanks for your application.' : 'Success!'}</p>
      </div>
      <div className="mt-1 mb-3" style={{ color: "#7A899A" }}>
        {
          session.hasCustomFlag('netx')
            ? <p className='mt-2 mb-4'>Our credit team is reviewing your <br />application and will be in touch shortly.</p>
            : 'Our VIP team is working on getting you the best rate, and will be in touch shortly.'
        }
      </div>
      {
        session.hasCustomFlag('netx') ? (
          <button
            style={{
              maxWidth: '400px',
              margin: '0 auto',
              lineHeight: '30px',
              marginBottom: '30px',
            }}
            className="button is-ck-blue is-large is-fullwidth has-text-weight-bold"
            onClick={() =>
            (window.location.href =
              'https://www.creditkey.com/webstaurantstoreterms')
            }
          >
            Learn More
          </button>
        ) : (
          <ReturnToMerchant merchant={merchant} />
        )
      }
    </div>
  );
}
